<template>
  <div class="engine-oil-recommend" v-if="data">
    <!-- 顶部菜单 -->
    <div class="other-menus">
      <div class="menu-item" @click="toMenuDetail(1)">
        <img
          src="@/assets/maintain/maintain_icon.png"
          alt=""
          class="menu-icon"
        />
        <span>保养周期</span>
      </div>
      <!-- <div class="menu-item" @click="getF6Token">
        <img class="deng" src="@/assets/maintain/deng.png" />
        <img class="rectangle1" src="@/assets/maintain/rectangle1.png" />
        <img class="rectangle4" src="@/assets/maintain/rectangle1.png" />
        <img class="rectangle2" src="@/assets/maintain/rectangle2.png" />
        <img class="rectangle3" src="@/assets/maintain/rectangle2.png" />
        <img
          class="menu-icon2"
          src="@/assets/maintain/icon-maintenance-lamp.png"
        />
        <span>保养灯归零</span>
      </div> -->

      <!-- <img
        class="new"
        src="https://select-oil-oss.vchangyi.com/wxapp/v2.1.4.1/news.gif"
      /> -->

      <div class="menu-item" @click="toMenuDetail(2)">
        <img
          src="@/assets/maintain/vehicle_icon.png"
          alt=""
          class="menu-icon"
        />
        <span>车辆配置</span>
      </div>
    </div>
    <!-- 机油推荐 -->
    <div class="engine-oil-products">
      <div class="subtitle">
        <div class="left">精准换油</div>
        <div class="right">
          <span
            v-if="
              data.goods_list.length > 0 &&
              data.vehicle &&
              data.vehicle.oil_use_remark &&
              data.vehicle.engine_oil_capacity
            "
            class="oil-sign"
            >*</span
          >
          <span v-if="data.vehicle.engine_oil_capacity">机油加注量：</span>
          <span class="oil-value" v-if="data.vehicle.engine_oil_capacity"
            >{{ data.vehicle.engine_oil_capacity }}L</span
          >
          <span v-else>暂无推荐</span>
        </div>
      </div>
      <!-- 施工提醒 -->
      <div
        v-if="
          data.goods_list.length > 0 &&
          data.vehicle &&
          data.vehicle.oil_use_remark
        "
        class="construction-reminder"
      >
        <div
          id="remark-text"
          class="reminder-text line-h-16"
          :class="{ expand: is_expand }"
        >
          <div v-if="show_expand" class="more-button-box">
            <div class="more-button" @click="expand">
              <span>{{ is_expand ? "收起" : "展开" }}</span>
              <img
                class="icon-arrow"
                src="https://select-oil-oss.vchangyi.com/wxapp/v2.1.4.1/icon-arrow-bottom-red.png"
              />
            </div>
          </div>
          <span class="line-h-16 font-bold">*施工提醒：</span>
          {{ data.vehicle.oil_use_remark }}
        </div>
      </div>
      <!-- 商品列表 -->
      <template v-if="data.goods_list.length > 0">
        <div
          class="product-item"
          v-for="(item, index) in data.goods_list"
          :key="index"
          @click="goDetail(item)"
        >
          <img :src="item.url" alt="" class="oil-img" />
          <div class="oil-desc">
            <div class="oil-name">
              <img
                align="left"
                v-if="item.is_best_goods == 1"
                src="@/assets/maintain/is_best_icon.png"
                alt=""
                class="oil-tag"
              />
              {{ item.name }}
            </div>
            <div class="more">
              <span>查看详情</span
              ><img
                src="@/assets/maintain/arrow_right.png"
                alt=""
                class="more-icon"
              />
            </div>
          </div>
        </div>
      </template>
      <!-- 无机油推荐缺省展示 -->
      <div class="no-products" v-else>
        <img
          src="@/assets/maintain/no_oil_empty.png"
          alt=""
          class="empty-icon"
        />
        <div class="tip">{{data.empty_msg ? data.empty_msg: '暂无机油推荐'}}</div>
        <div class="reselect-button" @click="back">重新选择其他车辆</div>
      </div>
      <!-- 分割线 -->
      <div
        class="split-line"
        v-if="
          data.goods_list.length > 0 &&
          (data.tips || data.vehicle.oil_norm_grade)
        "
      >
        <div class="split-item" v-for="item in 50" :key="item"></div>
      </div>
      <!-- 备注说明 -->
      <div
        class="note-desc"
        v-if="data.goods_list.length > 0 && data.tips != ''"
      >
        <span class="note">备注说明：</span>
        <span class="tip">{{ data.tips }}</span>
      </div>
      <!-- 原厂机油级别 -->
      <div
        class="oil-level"
        v-if="
          data.goods_list.length > 0 &&
          data.vehicle &&
          data.vehicle.oil_norm_grade
        "
      >
        <span class="note">原厂机油级别：</span>
        <span class="tip">{{ data.vehicle.oil_norm_grade }}</span>
      </div>
      <!-- 施工提醒 -->
      <!-- <div
        class="work-tip oil-level"
        v-if="
          data.goods_list.length > 0 &&
          data.vehicle &&
          data.vehicle.oil_use_remark
        "
      >
        <span class="note">施工提醒：</span>
        <span class="tip">{{ data.vehicle.oil_use_remark }}</span>
      </div> -->
    </div>
    <!-- 其他保养项目推荐 -->
    <div class="other-maintain">
      <div class="subtitle">其他保养项目推荐</div>
      <div
        class="maintain-item"
        v-for="(item, index) in maintenance_item_recommendation"
        :key="index"
      >
        <img :src="item.parts_icon" alt="" class="item-img" />
        <div class="maintain-name">{{ item.parts_name }}</div>
        <div class="maintain-desc">{{ item.parts_attribute }}</div>
      </div>
    </div>
    <!-- 免责声明 -->
    <section>
      <div class="declaration" v-if="isFirst" @touch.prevent>
        <div class="tip-dialog">
          <div class="close-button" @click="hideTipDialog">
            <img src="@/assets/maintain/icon-gray-close.png" />
          </div>
          <div class="title">免责声明</div>
          <div>
            <div class="content">
              <span class="paragraph"
                >在用户选择产品之前，核实车辆配置信息和原厂推荐机油标准是首要前提。
                具体用油标准请以车主保养手册或原厂技术公告信息为准。
                部分品牌车型在切换成国6排放标准发动机后，会要求使用新的机油标准，如大众、奥迪、保时捷、斯柯达、西亚特、宾利等品牌。对于这部分车型，请务必核实机油加注盖/机舱内说明/车主手册等对机油的要求。
                正确的机油液位对发动机正常运行至关重要，机油的液位需要在满足原厂测试要求下位于机油尺（或电子机油尺）上下刻度之间，选油助手推荐的加注量仅作为参考。
              </span>
            </div>
          </div>
          <div class="confirm-button" @click="hideTipDialog">
            我已阅读并同意免责声明
          </div>
        </div>
      </div>
    </section>
    <!-- <fab-button v-if="uuid_ready"></fab-button> -->
  </div>
</template>

<script>
import api from "@/apis/maintenance-api";
import Vue from "vue";
import $ from "jquery";
import { setStatistics } from "@/utils/common/index.js";
import { userQueryCarModelRecord } from "@/utils/data-burial";
import { maintenance_item_recommendation } from "./constants/maintain-list";
// import FabButton from "@/components/FabButton.vue";
// import Banner from "@/divs/maintenance/components/Banner.vue";
Vue.directive("iosInput", {
  // eslint-disable-next-line no-unused-vars
  bind(el, binding) {
    var u = navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
    setTimeout(function () {
      if (isiOS) {
        $("input").css("height", "0.66rem");
      }
    });
  },
});
export default {
  name: "engine-oil-recommend",
  // components: { FabButton, Banner },
  props: {
    query: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      recommendData: "",
      maintenance_item_recommendation: maintenance_item_recommendation,
      currentMi: "",
      data: {
        goods_list: [],
        vehicle: {},
      },
      loadData: false,
      isFirst: true,
      isVin: false, // 是否是输入或者扫描vin码进入
      vehicle_info: {},
      uuid_ready: false,
      show_expand: false, // 是否显示施工提醒“展开/收起”按钮
      is_expand: false, // 是否展开“施工提醒”
    };
  },
  created() {},
  async mounted() {
    this.vehicle_id = this.query.vehicle_id || "";
    this.isVin =
      this.query.internal_from && this.query.internal_from.indexOf("vin") !== -1
        ? true
        : false;
    let timestamp = Date.parse(new Date());
    let is_first = window.localStorage.getItem("ISFIRSTTIME");
    // 获取是否是第一次进入油量匹配
    if (is_first && timestamp - is_first <= 2592000000) {
      this.isFirst = false;
    }
    await this.getMaintenance();
    // await this.fetchVehicleDetail();
    await this.queryDataRecord();
    this.uuid_ready = true;
  },
  methods: {
    toMenuDetail(type) {
      if (type == 1) {
        this.$router.push({
          path: "/maintenance-cycle",
          query: {
            levelId: this.vehicle_id,
            scheme_id: this.query.scheme_id,
          },
        });
      } else {
        this.$router.push({
          path: "/maintenance-config",
          query: { vehicle_id: this.vehicle_id },
        });
      }
    },
    // 获取车型详情
    async fetchVehicleDetail() {
      try {
        const res = await api.getVehicleDetailApi({
          vehicle_id: this.vehicle_id,
        });
        if (res.code === 0) {
          // console.log(res);
          this.vehicle_info = res.data;
          // console.log(res.data);
        } else {
          this.$toast.show({
            showTime: 3,
            message: "获取车型详情失败",
            style: "error",
          });
        }
      } catch (error) {
        error && console.log("获取车型详情失败！");
      }
    },

    // 关闭免责声明
    hideTipDialog() {
      console.log(233);
      var timestamp = Date.parse(new Date());
      window.localStorage.setItem("ISFIRSTTIME", timestamp);
      this.isFirst = false;
    },

    //反馈
    feedback() {
      this.$router.push({
        path: "/maintenance-feedback",
        query: { id: "1" },
      });
    },
    // 查询数据记录
    async queryDataRecord() {
      console.log(localStorage.getItem("OILUSER"));
      if (!localStorage.getItem("OILUSER")) {
        await setStatistics.apply(this, []);
      }
      const uuid = localStorage.getItem("OILUSER");
      const { internal_from, vehicle_id } = this.query;
      const basic_info = {
        choose_vehicle_id: vehicle_id,
        menu_type: 1,
        uuid,
        scheme_id: this.query.scheme_id || this.query.id,
        search_type:
          internal_from === "photo_vin"
            ? 2
            : internal_from === "text_vin"
            ? 3
            : 1,
      };
      let goods_info = {};
      if (this.data.goods_list.length > 0) {
        const engine_oil_goods_list = this.data.goods_list;
        const high_temp = engine_oil_goods_list.filter(
          (i) => i.is_best_goods === 1
        )[0];
        const low_temp = engine_oil_goods_list.filter(
          (i) => i.is_best_goods === 0
        )[0];
        goods_info = {
          goods_low_mid: low_temp ? low_temp.mid : "",
          goods_low_name: low_temp ? low_temp.name : "",
          goods_high_mid: high_temp ? high_temp.mid : "",
          goods_high_name: high_temp ? high_temp.name : "",
        };
      }
      // console.log(this.data.goods_list, goods_info);
      await userQueryCarModelRecord.apply(this, [basic_info, goods_info]);
    },

    // 获取推荐机油商品列表
    async getMaintenance() {
      let self = this;
      let loading = this.$loading;
      loading.show("加载中...");
      const params = {
        vehicle_id: this.vehicle_id,
        grade_type: this.query.viscosity_type,
        scheme_id:
          this.query.scheme_id || window.sessionStorage.getItem("OILVERSION"),
      };
      try {
        const res = await api.getOilRecommendGoodsListApi(params);
        loading.hide();
        this.show_expand = false;
        this.loadData = true;
        if (res.code == 0) {
          let temp_list = [];
          res.data.goods_list.forEach((i) => {
            if (i.is_best_goods === 1) {
              temp_list.unshift(i);
            } else {
              temp_list.push(i);
            }
          });
          res.data.goods_list = temp_list;
          this.data = res.data;
          if (res.data.parts_list && res.data.parts_list.length > 0) {
            this.maintenance_item_recommendation = res.data.parts_list;
          }
        } else {
          self.$toast.show({
            showTime: 2,
            message: res.message,
            style: "error",
          });
        }
        this.loadData = true;
        this.$nextTick(() => {
          const remark_text = document.querySelector("#remark-text");
          if (remark_text) {
            this.show_expand =
              remark_text.scrollHeight > remark_text.clientHeight;
          }
        });
      } catch (error) {
        console.log("获取机油推荐商品失败", error);
      }
    },

    // 去机油商品详情
    goDetail(params) {
      const OILSHARE = sessionStorage.getItem("OILSHARE");
      if (JSON.parse(OILSHARE).goods_jump_status !== 1) return;
      this.$router.push({
        path: "/maintenance-good",
        query: {
          goods_id: params.id,
          scheme_id: this.query.scheme_id,
        },
      });
    },

    back() {
      this.$router.push({
        path: "/home",
        query: {
          id:
            this.query.scheme_id || window.sessionStorage.getItem("OILVERSION"),
        },
      });
    },
    /**
     * 展开/收起施工提醒
     */
    expand() {
      this.is_expand = !this.is_expand;
    },
    /**
     * 跳转F6保养灯
     * @param {*} e
     * @returns
     */
    async getF6Token() {
      let loading = this.$loading;
      loading.show("加载中...");
      try {
        const res = await api.getF6TokenApi({
          uuid: localStorage.getItem("OILUSER"),
          vehicle_id: this.vehicle_id,
        });
        loading.hide();
        if (res.code === 0) {
          const t = Number(new Date());
          console.log(window.NODE_ENV);
          const host =
            window.NODE_ENV == "development"
              ? "http://shop-pre.f6car.cn"
              : "https://shop.f6car.cn";
          const path = `${host}/data/shell#/guidPage?token=${res.data.f6_token}&mid=${res.data.mid}&moduleConfigId=6&time=${t}`;
          console.log(path, "---path");
          window.location.href = path;
        } else {
          self.$toast.show({
            showTime: 2,
            message: res.message,
            style: "error",
          });
        }
      } catch (error) {
        loading.hide();
        console.log("跳转F6保养灯失败", error);
      }
    },
  },
};
String.prototype.maxLength = function (x) {
  // x英文字节数
  var str = this;
  for (var i = 0; i < this.length; i++) {
    if (this.charCodeAt(i) > 127 || this.charCodeAt(i) == 94) {
      x--;
      if (this.length > x) {
        str = this.substring(0, x) + "...";
      }
    } else {
      if (this.length > x) {
        str = this.substring(0, x) + "...";
      }
    }
  }
  console.log(x);

  return str;
};
</script>

<style lang="less" scoped>
@import "../../../style/config/variables";
@import "../../../style/config/mixins/border";

.engine-oil-recommend {
  display: flex;
  flex-direction: column;
  width: 100%;
  // 顶部菜单
  .other-menus {
    width: 100%;
    height: 85/100rem;
    background: linear-gradient(180deg, #fbd119 0%, #fbc207 100%);
    box-shadow: 0px 3/100rem 20/100rem 0px rgba(251, 220, 106, 1);
    border-radius: 20/100rem;
    display: flex;
    justify-content: space-between;
    position: relative;
    margin-bottom: 27/100rem;
    &::after {
      content: "";
      width: 1/100rem;
      height: 30/100rem;
      background-color: #ffffff;
      opacity: 0.5;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .menu-item {
      width: 50%;
      color: #333333;
      font-size: 24/100rem;
      color: #333333;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      img {
        width: 41/100rem;
        height: 41/100rem;
        margin-right: 3/100rem;
      }
      .menu-icon2 {
        width: 36/100rem;
        height: 32/100rem;
        margin-right: 10/100rem;
      }
      .deng {
        position: absolute;
        top: 7/100rem;
        left: 10/100rem;
        width: 64/100rem;
        height: 68/100rem;
        opacity: 1;
        animation: flicker 0.7s ease-in-out 1.8s both 3;
      }
      .rectangle1 {
        position: absolute;
        top: -10/100rem;
        left: -62/100rem;
        width: 98/100rem;
        height: 124/100rem;
        opacity: 0;
        animation: move 1s ease-in-out;
      }
      .rectangle2 {
        position: absolute;
        top: -10/100rem;
        left: 0;
        width: 98/100rem;
        height: 124/100rem;
        opacity: 0;
        animation: move2 1s ease-in-out 0.25s;
      }
      .rectangle3 {
        position: absolute;
        top: -10/100rem;
        left: -62/100rem;
        width: 98/100rem;
        height: 124/100rem;
        opacity: 0;
        animation: move 1s ease-in-out 0.5s;
      }
      .rectangle4 {
        position: absolute;
        top: -10/100rem;
        left: -62/100rem;
        width: 98/100rem;
        height: 124/100rem;
        opacity: 0;
        animation: move 1s ease-in-out 0.8s;
      }
    }
    .new {
      position: absolute;
      top: -16/100rem;
      right: -50/100rem;
      width: 112/100rem;
      height: 70/100rem;
      opacity: 0;
      animation: show 0.2s ease-in-out 1s forwards;
    }
  }
  // 机油推荐
  .engine-oil-products {
    display: flex;
    flex-direction: column;
    background: #ffffff;
    box-shadow: 0px 10/100rem 27/100rem 0px rgba(207, 207, 207, 0.2);
    border-radius: 20/100rem;
    padding: 27/100rem;
    padding-bottom: 0;
    // 副标题
    .subtitle {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 26/100rem;
      .left {
        font-weight: bold;
        color: #333333;
        font-size: 27/100rem;
      }
      .right {
        color: #666666;
        font-size: 20/100rem;
        span {
          &:last-child {
            color: #fbc60c;
          }
        }
        .oil-sign {
          color: #df2c2f;
          font-size: 24/100rem;
          font-weight: 600;
          line-height: 26/100rem;
          margin-right: 2/100rem;
        }
        .oil-value {
          font-weight: bold;
          font-size: 27/100rem;
        }
      }
    }
    // 施工提醒
    .construction-reminder {
      margin-top: 17/100rem;
      margin-bottom: 26/100rem;
      padding: 9/100rem 14/100rem;
      color: #df2c2f;
      font-size: 17/100rem;
      font-weight: 400;
      background: rgba(223, 44, 47, 0.1);
      border-radius: 7/100rem;
      display: flex;
      .font-bold {
        font-weight: bold;
      }
      .line-h-16 {
        line-height: 27/100rem;
      }
      .reminder-text {
        max-height: 81/100rem;
        word-break: break-all;
        // display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
        &.expand {
          max-height: none;
          -webkit-line-clamp: none;
          -webkit-box-orient: inline-axis;
          overflow: visible;
          .more-button-box {
            &::before {
              display: none;
            }
            .more-button .icon-arrow {
              transform: rotate(180deg);
            }
          }
        }
        &::before {
          content: "";
          float: right;
          height: 100%;
          margin-top: -24/100rem;
        }
        .more-button-box {
          position: relative;
          float: right;
          clear: both;
          padding-left: 37/100rem;
          &::before {
            content: "…";
            position: absolute;
            top: 50%;
            left: -6/100rem;
            transform: translateY(-50%);
          }
          .more-button {
            color: #df2c2f;
            font-size: 14/100rem;
            font-weight: bold;
            width: 55/100rem;
            height: 22/100rem;
            border-radius: 7/100rem;
            background-color: #ffffff;
            padding-left: 7/100rem;
            line-height: 22/100rem;
            display: flex;
            justify-content: center;
            align-items: center;
            .icon-arrow {
              width: 14/100rem;
              height: 7/100rem;
              margin-left: 2/100rem;
              display: inline-block;
            }
          }
        }
      }
    }
    // 机油产品
    .product-item {
      width: 100%;
      display: flex;
      margin-bottom: 26/100rem;
      padding: 3/100rem 0;
      .oil-img {
        width: 123/100rem;
        height: 123/100rem;
        border-radius: 9/100rem;
        margin-right: 17/100rem;
        flex-shrink: 0;
      }
      .oil-desc {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .oil-name {
          color: #333333;
          font-size: 20/100rem;
          .oil-tag {
            width: 44/100rem;
            height: 24/100rem;
            margin-right: 5/100rem;
          }
        }
        .more {
          color: #fbc409;
          font-size: 17/100rem;
          font-weight: bold;
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .more-icon {
            width: 10/100rem;
            height: 15/100rem;
            margin-left: 7/100rem;
          }
        }
      }
    }
    // 无机油推荐展示
    .no-products {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 0 auto;
      .empty-icon {
        width: 133/100rem;
        height: 133/100rem;
        margin-bottom: 10/100rem;
      }
      .tip {
        color: #666666;
        font-size: 24/100rem;
        margin-bottom: 27/100rem;
        text-align: center;
      }
      .reselect-button {
        width: 246/100rem;
        height: 55/100rem;
        background: linear-gradient(180deg, #fbd119 0%, #fbc207 100%);
        box-shadow: 0px 3/100rem 20/100rem 0px rgba(251, 220, 106, 1);
        border-radius: 40/100rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: #333333;
        font-size: 24/100rem;
        margin-bottom: 55/100rem;
      }
    }
    .split-line {
      height: 1/100rem;
      width: 394/100rem;
      white-space: nowrap;
      margin-bottom: 20/100rem;
      display: flex;
      overflow: hidden;
      .split-item {
        width: 12/100rem;
        flex-shrink: 0;
        height: 1/100rem;
        background-color: #eee;
        margin-right: 10/100rem;
      }
    }
    // 备注说明
    .note-desc {
      width: 100%;
      color: #666666;
      font-size: 17/100rem;
      line-height: 26/100rem;
      margin-bottom: 13/100rem;
      .note {
        font-weight: bold;
      }
    }
    // 原厂机油级别
    .oil-level {
      width: 100%;
      color: #666666;
      font-size: 17/100rem;
      line-height: 26/100rem;
      margin-bottom: 13/100rem;
      .note {
        font-weight: bold;
      }
    }
    .work-tip {
      margin-bottom: 20/100rem;
    }
  }
  // 其他保养项目推荐
  .other-maintain {
    display: flex;
    flex-direction: column;
    .subtitle {
      color: #333333;
      font-size: 27/100rem;
      font-weight: bold;
      margin-top: 34/100rem;
      margin-bottom: 17/100rem;
    }
    .maintain-item {
      display: flex;
      flex-direction: column;
      padding: 27/100rem 0 26/100rem 26/100rem;
      background: #ffffff;
      box-shadow: 0px 10/100rem 27/100rem 0px rgba(207, 207, 207, 0.2);
      border-radius: 20/100rem;
      margin-bottom: 17/100rem;
      .item-img {
        width: 77/100rem;
        height: 77/100rem;
        margin-bottom: 2/100rem;
      }
      .maintain-name {
        color: #404040;
        font-size: 24/100rem;
        font-weight: bold;
        margin-bottom: 3/100rem;
      }
      .maintain-desc {
        color: #999999;
        font-size: 20/100rem;
      }
    }
  }

  //页面样式
  .height0 {
    height: 0 !important;
    overflow: hidden;
  }

  .ios-input {
    margin-top: -4/100rem;
  }

  .header {
    background: url("../../../assets/maintenance/bg.png") no-repeat;
    padding: 0 20/100rem;
    padding-bottom: 170/100rem;
    background-size: 100% 100%;

    .top {
      justify-content: space-between;
      align-items: center;
      min-height: 110/100rem;
      position: relative;
      margin: 0 -20/100rem;
      padding: 0 20/100rem;

      &:after {
        .Pseudo-border-after();
        background: #fff;
      }

      @fd: 0.64rem;

      .title {
        color: #fff;
        align-items: center;
        word-break: break-all;
        width: (calc(~"100% - @{fd}"));
        overflow: hidden;
        font-weight: 800;
        .line {
          line-height: 34/100rem;
        }

        span {
          margin-right: 15/100rem;
        }
        .tips {
          padding-top: 8/100rem;
          font-weight: 400;
        }
      }

      .feedback {
        margin-top: 0.05rem;
        float: right;
        text-align: center;
        line-height: 1;
        width: @fd;
        margin-left: 30/100rem;

        span {
          color: #fff;
          line-height: 1;
          display: block;
          margin-top: 8/100rem;
        }

        i {
          color: #fff;
          line-height: 1;
          display: block;
        }
      }
    }

    .nav {
      overflow: hidden;
      color: #fff;
      padding: 28/100rem 0 30/100rem 0;
      line-height: 1;

      .cycle,
      .config {
        position: relative;
        width: 50%;
        text-align: center;
        float: left;
      }

      .cycle:after {
        content: "";
        display: block;
        position: absolute;
        right: 0;
        height: 29/100rem;
        background: #fff;
        width: 1px;
        top: 50%;
        margin-top: -14/100rem;
        transform: scaleX(0.5);
      }
    }

    .search {
      height: 70/100rem;
      line-height: 70/100rem;
      background: #fff;
      border-radius: 100px;
      padding: 0 20/100rem;

      .tip {
        float: left;
        margin-right: 20/100rem;

        i {
          color: #b3b2b2;
          float: left;
          margin-right: 15/100rem;
        }

        span {
          float: right;
        }
      }

      .int {
        float: left;
        width: 45%;
        justify-content: space-between;
        flex-grow: 1;
        @diff: 80/100rem;

        span {
          margin-right: 10/100rem;
          color: #ffd301;
          width: @diff;
          text-align: right;
          line-height: 70/100rem;
        }

        input {
          width: calc(~"100% - @{diff}");
          //  height: 66/100rem;
        }

        ::-webkit-input-placeholder {
          /* WebKit browsers */
          color: #999;
          //font-size: 14px;
        }

        :-moz-placeholder {
          /* Mozilla Firefox 4 to 18 */
          color: #999;
          font-size: 14px;
        }

        ::-moz-placeholder {
          /* Mozilla Firefox 19+ */
          color: #999;
          font-size: 14px;
        }

        :-ms-input-placeholder {
          /* Internet Explorer 10+ */
          color: #999;
          font-size: 14px;
        }
      }
    }
  }

  .main {
    padding: 20/100rem 15/100rem 0 15/100rem;
    margin-top: -1.7rem;

    .recommend {
      background: #fff;
      border-radius: 8/100rem;
      min-height: 4.9rem;
      padding-bottom: 20/100rem;

      header {
        padding: 23/100rem 20/100rem;
        align-items: center;
        justify-content: space-between;

        .title {
          color: #fff;
          height: 50/100rem;
          line-height: 50/100rem;
          padding: 0 40/100rem 0 25/100rem;
          margin-left: -35/100rem;
          background: #dd1d21;
          position: relative;
          border-radius: 2/100rem;

          &:after {
            content: "";
            position: absolute;
            right: -2/100rem;
            top: 0;
            height: 0;
            width: 0;
            border-top: 25/100rem solid transparent;
            border-bottom: 25/100rem solid transparent;
            border-right: 15/100rem solid #fff;
          }
        }

        .type {
          margin-left: 15/100rem;
          float: right;

          span {
            color: #dd1d21;
          }
        }
      }

      .content {
        padding: 0 20/100rem 30/100rem 20/100rem;
        justify-content: space-between;

        .item {
          width: 2.8rem;
          position: relative;

          &:after {
            content: "";
            display: block;
            width: 100%;
            height: 6/100rem;
            background: #dd1d21;
            position: absolute;
            bottom: 0/100rem;
          }

          img {
            width: 2.8rem;
            height: 2.8rem;
          }

          p {
            float: left;
            line-height: 34/100rem;
            position: relative;
            padding-bottom: 15/100rem;
          }

          .chiji {
            float: left;
            //width: 50/100rem;
            height: 28/100rem;
            line-height: 28/100rem;
            text-align: center;
            color: #dd1d21;
            margin-right: 10/100rem;
            margin-top: 2/100rem;
            position: relative;
            padding: 0 3/100rem;

            &:after {
              .Pseudo-btnBorder-after(@border-width: 1px 1px 0.5px 1px, @border-color: #DD1D21, @border-style: solid, @radius: 0px);
            }
          }
        }
      }

      .mark {
        padding: 0 20/100rem;
        color: #666;
        span {
          font-weight: 600;
          color: #333;
        }
      }
    }

    .noEngineOil {
      text-align: center;
      padding: 25/100rem 0;
      line-height: 1;

      img {
        height: 112/100rem;
      }

      .title {
        margin-top: 25/100rem;
      }

      .title-en {
        margin-top: 20/100rem;
        color: #dd1d21;
      }
    }

    .other-commehernd {
      background: #fff;

      margin: 0 -15/100rem;
      margin-top: 20/100rem;
      overflow: hidden;
      line-height: 1;

      header {
        padding: 30/100rem 20/100rem 15/100rem 20/100rem;
        align-items: center;

        .title {
          color: #fff;
          height: 50/100rem;
          line-height: 50/100rem;
          padding: 0 40/100rem 0 25/100rem;
          margin-left: -20/100rem;
          background: #dd1d21;
          position: relative;
          border-radius: 2/100rem;

          &:after {
            content: "";
            position: absolute;
            right: -2/100rem;
            top: 0;
            height: 0;
            width: 0;
            border-top: 25/100rem solid transparent;
            border-bottom: 25/100rem solid transparent;
            border-right: 15/100rem solid #fff;
          }
        }
      }

      .content {
        padding: 0 20/100rem;

        .item {
          line-height: 1;
          position: relative;
          background: #fff;

          &:after {
            .Pseudo-border-after();
          }

          .prediv {
            justify-content: space-between;
            align-items: center;
            position: relative;
            padding: 25/100rem 0;
            height: 1.12rem;

            &:after {
              .Pseudo-border-after();
            }

            i {
              color: #ccc;
              transition: 0.4s;
            }

            .describe {
              margin-top: 10/100rem;
            }

            .left {
              align-items: center;

              img {
                width: 60/100rem;
                margin-right: 15/100rem;
              }
            }
          }

          .show-detail {
            transform: rotate(180deg);
          }

          .detail {
            transition: 0.4s;
            height: max-content;

            .detail-item {
              height: 80/100rem;
              background: #f7f7f7;
              align-items: center;
              padding: 0 10/100rem;

              .brand-item {
                justify-content: space-between;
                align-items: center;
              }

              .logo {
                float: left;
                height: 100%;
                align-items: center;

                img {
                  width: 60/100rem;
                  height: 60/100rem;
                  margin-right: 10/100rem;
                }
              }

              .brand {
                overflow: hidden;
                float: left;
                height: 100%;
                align-items: center;

                img {
                  float: left;
                  width: 1.1rem;
                  height: 36/100rem;
                  background: #ccc;
                  margin-right: 15/100rem;
                }
              }

              .type {
                float: right;
                max-width: 50%;
                text-align: right;
                height: 100%;
                align-items: center;
                line-height: normal;
              }

              .brand-item {
                width: 100%;
                height: 100%;
                overflow: hidden;
                position: relative;

                &:after {
                  .Pseudo-btnBorder-after(@border-width: 1px 0px 0px 0px, @border-color: @hr-border-color, @border-style: dashed, @radius: 0px);
                  // background: #fff;
                }

                p {
                  position: relative;
                  height: 80/100rem;
                  align-items: center;
                  justify-content: space-between;
                  word-break: break-all;

                  &:after {
                    .Pseudo-btnBorder-after(@border-width: 0px 0px 1px 0px, @border-color: @hr-border-color, @border-style: dotted, @radius: 0px);
                  }
                }
              }
            }

            .detail-item:nth-child(1) {
              .brand-item {
                &:after {
                  border: none !important;
                }
              }
            }
          }
        }

        .item:nth-last-child(1) {
          &:after {
            height: 0;
          }
        }
      }

      .noborder {
        padding-bottom: 20/100rem;

        &:after {
          // height: 0 !important;
        }
      }
    }

    .noOther {
      min-height: 3.95rem;
      text-align: center;
      padding-top: 75/100rem;
      line-height: 1;

      img {
        height: 101/100rem;
      }

      .title {
        margin-top: 25/100rem;
      }

      .title-en {
        margin-top: 20/100rem;
        color: #dd1d21;
      }
    }
  }

  .last-no-bd {
    &:after {
      height: 0 !important;
    }
  }

  .declaration {
    position: fixed;
    height: 100vh;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.7);
    .tip-dialog {
      width: 521/100rem;
      // height: 799/100rem;
      display: flex;
      align-items: center;
      flex-direction: column;
      background-color: #fff;
      border-radius: 20/100rem;
      padding: 26/100rem 43/100rem 43/100rem;
      position: relative;
      .close-button {
        position: absolute;
        top: 0;
        right: 0;
        width: 86/100rem;
        height: 86/100rem;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 24/100rem;
          height: 24/100rem;
        }
      }
      .title {
        font-weight: bold;
        color: #333333;
        line-height: 38/100rem;
        letter-spacing: 2/100rem;
        font-size: 24/100rem;
        margin-bottom: 26/100rem;
      }
      .content {
        font-weight: 400;
        color: #666666;
        line-height: 38/100rem;
        font-size: 24/100rem;
        margin-bottom: 43/100rem;
      }
      .confirm-button {
        width: 341/100rem;
        height: 61/100rem;
        background: linear-gradient(180deg, #fbd119 0%, #fbc207 100%);
        box-shadow: 0px 3/100rem 20/100rem 0px rgba(251, 220, 106, 1);
        border-radius: 31/100rem;
        // position: absolute;
        // bottom: 30/100rem;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bold;
        color: #333333;
        font-size: 24/100rem;
        // left: 50%;
        // transform: translateX(-50%);
      }
    }

    .content-box {
      margin-top: 1.5rem;
      margin-left: 0.5rem;
      margin-right: 0.5rem;
      padding: 0.3rem;
      min-height: 60vh;
      background-color: #fff;
      border-radius: 0.04rem;
      padding-bottom: 0.9rem;
      position: relative;

      .text {
        height: 100%;
        overflow-y: scroll;
        line-height: 0.4rem;
      }

      .button-bottom {
        position: absolute;
        bottom: 0;
        height: 80/100rem;
        line-height: 80/100rem;
        border-radius: 0 0 0.04rem 0.04rem;
        background-color: #ffd301;
        color: #fff;
        width: 100%;
        text-align: center;
        left: 0;
      }
    }
  }
}

@keyframes flicker {
  0% {
    opacity: 0;
  }
  90% {
    opacity: 0.8;
  }
  100% {
    opacity: 0;
  }
}

@keyframes move {
  0% {
    left: -62/100rem;
    opacity: 0.5;
  }
  40% {
    opacity: 0.8;
  }
  60% {
    opacity: 1;
  }
  80% {
    opacity: 0.5;
  }
  100% {
    left: 248/100rem;
    opacity: 0;
  }
}
@keyframes move2 {
  0% {
    left: 0;
    opacity: 0.5;
  }
  40% {
    opacity: 0.8;
  }
  80% {
    opacity: 1;
  }
  80% {
    opacity: 0.8;
  }
  100% {
    left: 248/100rem;
    opacity: 0;
  }
}
@keyframes show {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
</style>
